import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock, Mail, ShieldCheck } from "lucide-react";
import { PillButton } from "../../components/ui/PillButton";
import { useApp } from "../../context/AppContext";
import { ASSETS } from "../../data/assets";
import { ADMIN_USER } from "../../data/mockData";

export default function AdminLogin() {
  const navigate = useNavigate();
  const { admin, login } = useApp();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  if (admin) return <Navigate to="/admin/dashboard" replace />;

  const submit = (e) => {
    e.preventDefault();
    const res = login(email, password);
    if (!res.ok) { toast.error(res.error); return; }
    navigate("/admin/dashboard");
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-6">
          <img src={ASSETS.logo} alt="BLTR 2026" className="h-16 mx-auto" />
          <p className="mt-2 font-display text-xl text-slate-700">Admin Portal</p>
        </div>
        <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-8">
          <h1 className="font-display text-2xl text-slate-800 flex items-center gap-2">
            <ShieldCheck className="w-6 h-6 text-sea" /> Masuk
          </h1>
          <form onSubmit={submit} className="mt-5 space-y-4">
            <label className="block">
              <span className="text-sm font-bold text-slate-600">Email</span>
              <div className="mt-1 relative">
                <Mail className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
                <input
                  type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                  data-testid="admin-email"
                  className="w-full rounded-lg border border-slate-300 focus:border-sea focus:ring-2 focus:ring-sea/30 outline-none pl-9 pr-3 py-2.5 font-semibold text-slate-700"
                  placeholder="admin@balitarun.id"
                />
              </div>
            </label>
            <label className="block">
              <span className="text-sm font-bold text-slate-600">Password</span>
              <div className="mt-1 relative">
                <Lock className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
                <input
                  type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                  data-testid="admin-password"
                  className="w-full rounded-lg border border-slate-300 focus:border-sea focus:ring-2 focus:ring-sea/30 outline-none pl-9 pr-3 py-2.5 font-semibold text-slate-700"
                  placeholder="••••••••"
                />
              </div>
            </label>
            <button
              type="submit"
              data-testid="admin-login-submit"
              className="w-full bg-sea text-white font-display rounded-lg py-3 hover:bg-sea-deep transition-colors"
            >
              Masuk ke Dashboard
            </button>
          </form>
          <div className="mt-4 text-xs text-slate-400 bg-slate-50 rounded-lg p-3">
            Demo login — Email: <b>{ADMIN_USER.email}</b> · Password: <b>{ADMIN_USER.password}</b>
          </div>
        </div>
      </div>
    </div>
  );
}
